export const FeatureFlagKey = {
  QuestDescription: 'quest-description',
  QuestEditing: 'quest-editing',
  QuestDeletion: 'quest-deletion',
  GameCreation: 'game-creation',
  GameEntitiesManagement: 'game-entities-management',
  Establishment: 'establishment',
} as const;

export type FeatureFlagKey = (typeof FeatureFlagKey)[keyof typeof FeatureFlagKey];
